import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useToast } from "../../../../../Hooks/UseToast";
import { useMenus } from "../hooks/useMenus";
import { cambiarEstadoMenu } from "../service/menusService";
import { getProveedores } from "../../proveedores/service/proveedoresService";
import MenusTable from "../components/MenusTable";
import ModalManager from "../modals/ModalManager";
import { MODAL_TYPES } from "../config/MODAL_TYPES";
import { ROW_ACTIONS } from "../config/ROW_ACTIONS";

const MenusPage = () => {
  const [filtroProveedor, setFiltroProveedor] = useState("");
  const { data, loading, refresh } = useMenus(filtroProveedor || undefined);
  const { showToast, Toast } = useToast();
  const [modal, setModal] = useState(null);
  const [proveedores, setProveedores] = useState([]);

  useEffect(() => {
    getProveedores()
      .then((res) => setProveedores(res || []))
      .catch(() => setProveedores([]));
  }, []);

  const openModal = (type, props = {}) => setModal({ type, ...props });
  const closeModal = () => setModal(null);

  const handleAction = async ({ type, row }) => {
    switch (type) {
      case ROW_ACTIONS.EDITAR:
        openModal(MODAL_TYPES.FORM, { menu: row });
        break;

      case ROW_ACTIONS.TOGGLE_ESTADO: {
        const nuevoEstado = Number(row.activo) === 1 ? 0 : 1;
        try {
          await cambiarEstadoMenu(row.id, nuevoEstado);
          showToast(nuevoEstado ? "Menú activado." : "Menú desactivado.", "success");
          refresh();
        } catch (err) {
          showToast(err.message || "Error al cambiar el estado.", "error");
        }
        break;
      }

      default:
        break;
    }
  };

  const proveedoresActivos = proveedores.filter((p) => Number(p.activo) === 1);

  return (
    <Box>
      <MenusTable
        data={data}
        loading={loading}
        onAction={handleAction}
        onNuevo={() => openModal(MODAL_TYPES.FORM, { menu: null })}
        proveedores={proveedores}
        filtroProveedor={filtroProveedor}
        onFiltroProveedorChange={setFiltroProveedor}
      />

      <ModalManager
        modal={modal}
        onClose={closeModal}
        refresh={refresh}
        showToast={showToast}
        proveedores={proveedoresActivos}
      />
      {Toast}
    </Box>
  );
};

export default MenusPage;
